export const CHANGE_THEMES = "CHANGE_THEMES";
export const ADD_TASK = "ADD_TASK";
export const DONE_TASK_COMPLETED = "DONE_TASK_COMPLETED";
export const DONE_TASK_TODO = "DONE_TASK_TODO";
export const EDIT_TASK = "EDIT_TASK";
export const DELL_TASK = "DELL_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
